import { Col, GRID } from '../../components/custom';

export default function DIS()
{
    return (
        <Col id='DIS' className='usecase'>
            <Col className='banner'>
                <span className='title'>Use Case : Hypothesis Testing on Customer Satisfaction Based on Demographics</span>
            </Col>
            <Col className='section objective'>
                <span className='title'>Objective</span>
                <span className='descsmall'>To determine whether there are significant differences in customer satisfaction scores based on <strong>demographic factors such as age, gender, and income level.</strong> The goal is to understand how different demographic groups perceive the product or service to tailor marketing strategies and product offerings accordingly.</span>
            </Col>
            <Col className='section methodology'>
                <span className='title'>Methodology</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Approach: One-Way ANOVA and Independent Samples T-Test</span>
                        <ul>
                            <li className='descsmall'>
                                <strong>Dependent Variable:</strong>
                                <ul>
                                    <li className='descsmall'>Customer Satisfaction Score (1-5 scale)</li>
                                </ul>
                            </li>
                            <li className='descsmall'>
                                <strong>Independent Variables (Demographics):</strong>
                                <ul>
                                    <li className='descsmall'><strong>Age</strong> (categorized into groups: 18-30, 31-45, 46-60, 61+)</li>
                                    <li className='descsmall'><strong>Gender</strong> (Male, Female)</li>
                                    <li className='descsmall'><strong>Income</strong> Level (Low, Medium, High — based on annual income)</li>
                                </ul>
                            </li> 
                        </ul>
                    </Col>
                    <Col className='part'>
                        <span className='desc'>Procedure</span>
                        <ul>
                            <li className='descsmall'><strong>Data Collection:</strong> Gather customer satisfaction survey data that includes demographic information such as age, gender, and income.</li> 
                            <li className='descsmall'>
                                <strong>Hypothesis Formulation:</strong>
                                <ul>
                                    <li className='descsmall'><strong>Null Hypothesis (H<sub>0</sub>):</strong> There is no significant difference in customer satisfaction scores based on demographic factors (age, gender, income).</li>
                                    <li className='descsmall'><strong>Alternative Hypothesis (H<sub>1</sub>):</strong> There is a significant difference in customer satisfaction scores based on demographic factors (age, gender, income).</li>
                                </ul>
                            </li>
                            <li className='descsmall'>
                                <strong>Statistical Tests:</strong>
                                <ul>
                                    <li className='descsmall'><strong>One-Way ANOVA</strong> for categorical demographics with more than two groups (e.g., age and income).</li>
                                    <li className='descsmall'><strong>Independent Samples T-Test</strong> for gender comparison (Male vs. Female).</li>
                                </ul>
                            </li>
                            <li className='descsmall'><strong>Significance Level:</strong> Set at <strong>α = 0.05</strong> for statistical significance.</li>
                        </ul>
                    </Col>
                </Col>
            </Col>
            <Col className='section results'>
                <span className='title'>Key Findings</span>
                <Col className='notTitle'>
                    <Col className='part'>
                        <span className='desc'>Hypothesis Testing Outcomes:</span>
                        <GRID className='_5x4'>
                            <span className='descsmall bold'>Demographic Factor</span>
                            <span className='descsmall bold'>Test Type</span>
                            <span className='descsmall bold'>F-statistic / T-statistic</span>
                            <span className='descsmall bold'>p-value</span>
                            <span className='descsmall bold'>Interpretation</span>
                            <span className='descsmall bold'>Age</span>
                            <span className='descsmall'>One-Way ANOVA</span>
                            <span className='descsmall'>4.20</span>
                            <span className='descsmall'>0.03</span>
                            <span className='descsmall left'>Significant difference in customer satisfaction based on <strong>age</strong>. Customers aged 31-45 and 46-60 report higher satisfaction than the younger and older age groups.</span>
                            <span className='descsmall bold'>Gender</span>
                            <span className='descsmall'>Independent T-Test</span>
                            <span className='descsmall'>-1.94</span>
                            <span className='descsmall'>0.05</span>
                            <span className='descsmall left'>Marginally significant difference between <strong>male and female</strong> satisfaction scores. <strong>Females</strong> report slightly higher satisfaction than <strong>males</strong>.</span>
                            <span className='descsmall bold'>Income</span>
                            <span className='descsmall'>One-Way ANOVA</span>
                            <span className='descsmall'>6.10</span>
                            <span className='descsmall'>0.002</span>
                            <span className='descsmall left'>Significant difference in satisfaction based on <strong>income level. High-income</strong> customers show the highest satisfaction, followed by medium and low-income groups.</span>
                        </GRID>
                    </Col>
                </Col>
            </Col>
            <Col className='section recommendations'>
                <span className='title'>Insightful Takeaway:</span>
                <ul>
                    <li className='descsmall'><strong>Age</strong> plays a significant role in customer satisfaction, with customers aged 31-60 showing the highest satisfaction. The younger and older groups (18-30 and 61+) appear to be less satisfied.</li>
                    <li className='descsmall'><strong>Gender</strong> shows a marginally significant difference, with <strong>females</strong> reporting slightly higher satisfaction than males.</li>
                    <li className='descsmall'><strong>Income</strong> is a strong predictor of customer satisfaction, with <strong>high-income customers</strong> expressing the most satisfaction with the product/service.</li>
                </ul>
            </Col>
        </Col>
    )
}